export const APP_ROOT_ELEMENT_ID = 'root';

export interface ILayoutService {
    readonly shouldUseWebappLayout: boolean;
    switchLayoutMode(): void;
}
